import { CATEGORIES } from '../../utils/constants/category';
import { FILTER_TYPES } from '../Filter/constants';
import { CIDS } from '../ProductsTable/constants';

/*
    QUICK_FILTERS: {
        [category_id]: {
            gutterTop: {
                type: boolean,
                default: false,
                description: 'Consider using "true" when first filter in group is slider, to add top margin'
            },
            filterGroups: {
                type: array of objects,
                description: 'Groups of filters that are in single column',
                items: {
                    id: {
                        type: string,
                        description: 'Id of filter group',
                    },
                    title: {
                        type: string,
                        description: 'Title of filter group',
                    },
                    filters: {
                        type: array of objects,
                        description: 'Filters that belong to specific filter group',
                        items: {
                            cid: {
                                type: string,
                                description: 'Cid of filter',
                            },
                            type: {
                                type: string,
                                default: null,
                                description: 'Alternate filter type (to reduce space and improve UX in Quick Filters).
                                            Example: Selection Group (radio buttons) in Filters panel
                                                    should be rendered as Chips in Quick Filters.',
                            },
                            align: {
                                type: string,
                                values: ['left', 'right'],
                                default: 'left',
                                description: 'Alignment of filter.
                                            Example: If "Select" is the type of first filter in filter group,
                                            it should be aligned to right and "gutterTop" of that group should be "false"
                                            to reduce vertical space.',
                            },
                            gutterBottom: {
                                type: boolean,
                                default: false,
                                description: 'Additional bottom margin for specific filter'
                            },
                        }
                    }
                }
            },
        }
    }
*/
export const QUICK_FILTERS = {
	[CATEGORIES.IGBT]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'igbtQF1',
				title: '',
				filters: [
					{
						cid: CIDS.BREAKDOWN_VOLTAGE_CES,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.COLLECTOR_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SATURATION_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.POWER_DISSIPATION,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'igbtQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.COPACKAGED_DIODE,
						type: null,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: true
					}
				]
			}
		]
	},
	[CATEGORIES.IPM]: {
		gutterTop: false,
		filterGroups: [
			{
				id: 'ipmQF1',
				title: '',
				filters: [
					{
						cid: CIDS.TOPOLOGY,
						type: FILTER_TYPES.SELECT,
						align: 'right',
						gutterBottom: true
					},
					{
						cid: CIDS.RATED_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.OUTPUT_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SATURATION_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.ON_STATE_RESISTANCE,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'ipmQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.MAX_POWER_FAMILY,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.JFET]: {
		gutterTop: false,
		filterGroups: [
			{
				id: 'jfetQF1',
				title: '',
				filters: [
					{
						cid: CIDS.CHANNEL_POLARITY,
						type: FILTER_TYPES.SELECT,
						align: 'right',
						gutterBottom: true
					},
					{
						cid: CIDS.BREAKDOWN_VOLTAGE_GSS,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.DRAIN_CURRENT_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.DRAIN_CURRENT_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'jfetQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.SMART_SWITCH]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'smartSwitchQF1',
				title: '',
				filters: [
					{
						cid: CIDS.ON_DS_RESISTANCE_TYPICAL_FOR_25_DEGREES,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TYPICAL_CURRENT_LIMIT_FOR_25_DEGREES,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.BREAKDOWN_VOLTAGE_DSS,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.POWER_DISSIPATION,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'smartSwitchQF2',
				title: '',
				filters: [
					{
						cid: CIDS.SWITCH_CONFIGURATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.MOSFET]: {
		gutterTop: false,
		filterGroups: [
			{
				id: 'singleMosfetQF1',
				title: '',
				filters: [
					{
						cid: CIDS.CHANNEL_POLARITY,
						type: FILTER_TYPES.CHIPS,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.TECHNOLOGY,
						type: FILTER_TYPES.CHIPS,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.BREAKDOWN_VOLTAGE_DSS,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.ON_STATE_DS_RESISTANCE_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.DRAIN_CURRENT_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.GATE_CHARGE_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SPICE_LIVE_MODEL_SUPPORTED,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.ELITE_PAIRING_STUDIO_SUPPORTED,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'singleMosfetQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.MOSFET_TYPE,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.GATE_LEVEL,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SILICON_FAMILY,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.MOSFET_CONFIGURATION,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.NEW_MOSFET_PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.OP_AMP]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'opAmplifierQF1',
				title: '',
				filters: [
					{
						cid: CIDS.OPERATION_AMPLIFIER_GROUP,
						type: FILTER_TYPES.CHIPS_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.GAIN_BANDWIDTH,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SLEW_RATE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.INPUT_OFFSET_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.INPUT_REFERRED_VOLTAGE_NOISE_DENSITY,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.QUIESCENT_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'opAmplifierQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.NUMBER_OF_CHANNELS,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.RAIL_TO_RAIL,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.ANALOG_BJT]: {
		gutterTop: false,
		filterGroups: [
			{
				id: 'analogBJTQF1',
				title: '',
				filters: [
					{
						cid: CIDS.ANALOG_TRANSISTORS_GROUP,
						type: FILTER_TYPES.CHIPS,
						align: 'right',
						gutterBottom: true
					},
					{
						cid: CIDS.CONTINUES_COLLECTOR_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.COLLECTOR_EMITTER_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.FORWARD_CURRENT_TRANSFER_RATIO_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TRANSITION_FREQUENCY,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.POWER_DISSIPATION,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.EMITTER_BASE_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'analogBJTQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.MOUNTING_TYPE,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.CONFIGURATION,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.POLARITY,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TYPE_OF_GENERAL_PURPOSE,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SPICE_LIVE_MODEL_SUPPORTED,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.DIGITAL_BJT]: {
		gutterTop: false,
		filterGroups: [
			{
				id: 'digitalBJTQF1',
				title: '',
				filters: [
					{
						cid: CIDS.V_I_ON_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_I_OFF_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.R1,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.R2,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONTINUES_COLLECTOR_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'digitalBJTQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONFIGURATION,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.POLARITY,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.RF_BJT]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'rfBJTQF1',
				title: '',
				filters: [
					{
						cid: CIDS.COLLECTOR_EMITTER_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TRANSITION_FREQUENCY,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONTINUES_COLLECTOR_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.FORWARD_CURRENT_TRANSFER_RATIO_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'rfBJTQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.POLARITY,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.ZENER_DIODE]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'zenerDiodeQF1',
				title: '',
				filters: [
					{
						cid: CIDS.TYPICAL_ZENER_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.MAX_POWER,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'zenerDiodeQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.POWER_DIODE]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'powerDiodeQF1',
				title: '',
				filters: [
					{
						cid: CIDS.TECHNOLOGY,
						type: FILTER_TYPES.CHIPS,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.REPETITIVE_REVERSE_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONTINUES_FORWARD_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.FORWARD_CURRENT_SURGE_PEAK,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.JUNCTION_CAPACITANCE_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'powerDiodeQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.DIODE_TYPE,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONFIGURATION,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.SMALL_SIGNAL_DIODE]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'smallSignalDiodeQF1',
				title: '',
				filters: [
					{
						cid: CIDS.REVERSE_VOLTAGE_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.FORWARD_CURRENT_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.REVERSE_CURRENT_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'smallSignalDiodeQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.RF_DIODE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONFIGURATION,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.GATE_DRIVER]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'gateDriverQF1',
				title: '',
				filters: [
					{
						cid: CIDS.TYPE_OF_POWER_SWITCH,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.DRIVE_SOURCE_CURRENT_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.DRIVE_SINK_CURRENT_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CLASS,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CC_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.ELITE_PAIRING_STUDIO_SUPPORTED,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'gateDriverQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.ISOLATION_TYPE,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TOPOLOGY,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.NUMBER_OF_OUTPUTS,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.COMPARATOR]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'comparatorQF1',
				title: '',
				filters: [
					{
						cid: CIDS.T_RES_TYP,
						type: null,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CC_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CC_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_IO_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.I_CC_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'comparatorQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.NUMBER_OF_CHANNELS,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.POWER_SUPPLY]: {
		gutterTop: false,
		filterGroups: [
			{
				id: 'psQF1',
				title: '\u00a0',
				filters: [
					{
						cid: CIDS.POWER_CONVERSION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.OUTPUT_VOLTAGE_TYPE,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.V_OUT_APLICATION_ORIENTED,
						type: FILTER_TYPES.INPUT,
						align: 'left',
						gutterBottom: true
					}
				]
			},
			{
				id: 'psQF2',
				title: '\u00a0',
				filters: [
					{
						cid: CIDS.V_IN_MAX,
						type: null,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.V_IN_MIN,
						type: null,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.OUTPUT_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.QUIESCENT_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.SWITCHING_FREQUENCY,
						type: null,
						align: 'left',
						gutterBottom: true
					}
				]
			},
			{
				id: 'psQF3',
				title: '\u00a0',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.TOPOLOGY,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONTROL_MODE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SPICE_LIVE_MODEL_SUPPORTED,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.SMART_POWER_STAGE]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'smartPowerStageQF1',
				title: '',
				filters: [
					{
						cid: CIDS.V_IN_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.I_OUT_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SWITCHING_FREQUENCY_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'smartPowerStageQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PWM_LEVEL,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.CLOCK_GENERATION]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'clockGenerationQF1',
				title: '',
				filters: [
					{
						cid: CIDS.INPUT_LEVEL,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.OUTPUT_LEVEL,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.F_OUT_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.F_IN_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CC_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'clockGenerationQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.PROTECTED_POWER_SWITCH]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'protectedPowerSwitchQF1',
				title: '',
				filters: [
					{
						cid: CIDS.PRODUCT_FAMILY,
						type: FILTER_TYPES.SELECT,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.I_OUT_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_IN_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_IN_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.ON_STATE_RESISTANCE,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'protectedPowerSwitchQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.FEATURE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CURRENT_LIMIT,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: true
					}
				]
			}
		]
	},
	[CATEGORIES.IMAGE_SENSORS]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'imageSensorsQF1',
				title: '',
				filters: [
					{
						cid: CIDS.SHUTTER_TYPE,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.MEGAPIXELS,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PIXEL_SIZE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.FRAME_RATE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.OPTICAL_FORMAT_NUMBER,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'imageSensorsQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.COLOR,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.OUTPUT_INTERFACE,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: true
					}
				]
			}
		]
	},
	[CATEGORIES.POWER_INTEGRATED_MODULE]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'powerIntegratedModuleQF1',
				title: '',
				filters: [
					{
						cid: CIDS.PIM_TECHNOLOGY,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.BREAKDOWN_VOLTAGE_DSS,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.RATED_CURRENT,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.SATURATION_VOLTAGE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.ON_STATE_DS_RESISTANCE_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_F_TYP,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'powerIntegratedModuleQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.CONFIGURATION,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.APPLICATION,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: true
					},
					{
						cid: CIDS.ELITE_PAIRING_STUDIO_SUPPORTED,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.VOLTAGE_REFERENCE]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'voltageReferenceQF1',
				title: '',
				filters: [
					{
						cid: CIDS.V_BR_TYP,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TOLERANCE,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.T_A_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.T_A_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.I_R_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'voltageReferenceQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.REF_TYPE,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: true
					}
				]
			}
		]
	},
	[CATEGORIES.LEVEL_TRANSLATOR]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'levelTranslatorQF1',
				title: '',
				filters: [
					{
						cid: CIDS.V_CCA_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CCA_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CCB_MIN,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_CCB_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.T_PD_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.I_O_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'levelTranslatorQF2',
				title: '',
				filters: [
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TYPE,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.INPUT_LEVEL,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.NUMBER_OF_CHANNELS,
						type: FILTER_TYPES.SELECT,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.ESD_PROTECTION_DIODE]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'esdProtectionDiodeQF1',
				title: '',
				filters: [
					{
						cid: CIDS.INTERFACE,
						type: FILTER_TYPES.SELECT,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.NUMBER_OF_LINES,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.DIRECTION,
						type: FILTER_TYPES.CHIPS,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.V_RWM_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.C_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'esdProtectionDiodeQF2',
				title: '',
				filters: [
					{
						cid: CIDS.PACKAGE_SIZE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	},
	[CATEGORIES.LED_DRIVER]: {
		gutterTop: true,
		filterGroups: [
			{
				id: 'ledDriverQF1',
				title: '',
				filters: [
					{
						cid: CIDS.CATEGORY,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.V_IN_MIN,
						type: null,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.V_IN_MAX,
						type: null,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.I_O_MAX,
						type: null,
						align: 'right',
						gutterBottom: false
					},
					{
						cid: CIDS.V_O_MAX,
						type: null,
						align: 'left',
						gutterBottom: false
					}
				]
			},
			{
				id: 'ledDriverQF2',
				title: '',
				filters: [
					{
						cid: CIDS.PACKAGE_TYPE,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.TOPOLOGY,
						type: FILTER_TYPES.SELECT_MULTIPLE,
						align: 'left',
						gutterBottom: false
					},
					{
						cid: CIDS.QUALIFICATION,
						type: FILTER_TYPES.CHIPS,
						align: 'left',
						gutterBottom: false
					}
				]
			}
		]
	}
};
